import { tokenKeyMapping } from "@/dto/model.dto";

export const apiKey: tokenKeyMapping = {
  accessToken: "accessToken",
  refreshToken: "refreshToken",
};
